// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__10TAV","requiredAsterisk":"Info_requiredAsterisk__34rof"};